/** Takes an arbitrary string and indexes into integer space of `size` */
export function hashToIndex(value, size) {
    return Math.abs(hashCode(value)) % size;
}
export function hashCode(value) {
    let hash = 0;
    for (let i = 0; i < value.length; i++) {
        const char = value.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
}
export function randomItem(items) {
    return items[Math.floor(Math.random() * items.length)];
}
//# sourceMappingURL=random.js.map